module.exports = [{
      plugin: require('../../../common/temp/node_modules/.pnpm/gatsby-plugin-manifest@2.4.37_gatsby@2.26.1/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#F7F7F7","theme_color":"#F7F7F7","display":"minimal-ui","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":null},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
